import { isValid, parse } from 'date-fns'
import { z } from 'zod'

import { Status } from './status.enum'

function isISODate (value: string): boolean {
  let valid = false

  try {
    valid = isValid(parse(value, 'yyyy-MM-dd', new Date()))
  } catch (err) {}

  return valid
}

export let diagnosisSchema = z.object({
  id: z.string(),

  chapter: z.string()
    .nullable()
    .optional(),

  category: z.string()
    .nullable()
    .optional(),

  claims: z.number()
    .nullable()
    .optional(),

  first_claim_date: z.string()
    .refine(isISODate)
    .nullable()
    .optional(),

  last_claim_date: z.string()
    .refine(isISODate)
    .nullable()
    .optional(),

  code: z.string()
    .nullable()
    .optional(),

  description: z.object({
    code: z.string()
      .optional()
      .nullable(),

    descriptor: z.string()
      .optional()
      .nullable()
  })
    .nullable()
    .optional(),

  provider_name: z.array(
    z.string()
      .optional()
      .nullable()
  )
    .nullable()
    .optional(),

  icd: z.string()
    .nullable()
    .optional(),

  severity: z.number()
    .nullable()
    .optional(),

  status: z.nativeEnum(Status)
    .nullable()
    .optional(),

  comment: z.string()
    .nullable()
    .optional()
})

export let diagnosesSchema = z.array(diagnosisSchema)
